import React from 'react';
import { Link } from 'react-router-dom';
import './featureContent.css';

function FeatureCta({ title, description, ctaTo, ctaHref, ctaLabel, children }) {
    const destination = ctaHref || ctaTo;
    const isExternal = typeof destination === 'string' && (/^https?:\/\//i.test(destination) || destination.startsWith('//'));

    return (
        <section className="fc-cta-section sp-90">
            <div className="container">
                <h2 className="h-1 h-bold fc-cta-title">{title}</h2>
                {description && <p className="fc-cta-description">{description}</p>}
                {isExternal ? (
                    <a
                        href={destination}
                        className="fc-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {ctaLabel}
                    </a>
                ) : (
                    <Link to={destination} className="fc-btn">{ctaLabel}</Link>
                )}
                {children}
            </div>
        </section>
    );
}

export default FeatureCta;
